import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AiLight24 = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 28 28" {...props}>
    <g filter="url(#filter0_ddd_1540_135037)">
      <rect x="2" y="2" width="24" height="24" rx="6" fill="white" shapeRendering="crispEdges" />
      <g filter="url(#filter1_ddd_1540_135037)">
        <path
          d="M10.2103 15.0297L13.4444 16L13.855 20.4339C13.8999 20.9194 14.5423 21.06 14.786 20.6377L18.3686 14.4278C18.691 13.869 18.4077 13.1556 17.7897 12.9703L14.5556 12L14.145 7.56608C14.1001 7.08056 13.4577 6.93997 13.214 7.36232L9.63142 13.5722C9.30903 14.131 9.59232 14.8444 10.2103 15.0297Z"
          fill="url(#paint0_linear_1540_135037)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ddd_1540_135037"
        x="0"
        y="0"
        width="28"
        height="28"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1540_135037" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1540_135037"
          result="effect2_dropShadow_1540_135037"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1540_135037"
          result="effect3_dropShadow_1540_135037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1540_135037"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_1540_135037"
        x="7.49609"
        y="5.11182"
        width="13.0078"
        height="17.7764"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1540_135037" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1540_135037"
          result="effect2_dropShadow_1540_135037"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1540_135037"
          result="effect3_dropShadow_1540_135037"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1540_135037"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1540_135037"
        x1="17.9064"
        y1="6"
        x2="5.33752"
        y2="16.0547"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
